import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// SEO metadata for all pages
export const seoData = {
  '/': {
    title: 'Guía NFL en Español | Aprende Fútbol Americano desde Cero',
    description: 'La guía definitiva de NFL en español. Aprende reglas, posiciones, estrategias y todo sobre fútbol americano explicado de forma sencilla. De principiante a experto.',
    keywords: 'NFL, fútbol americano, guía NFL español, aprender NFL, reglas NFL, posiciones NFL'
  },
  '/blog': {
    title: 'Blog NFL en Español | Artículos y Guías de Fútbol Americano',
    description: 'Artículos completos sobre NFL en español. Guías para principiantes, explicaciones de reglas, posiciones, Super Bowl y todo lo que necesitas saber.',
    keywords: 'blog NFL, artículos NFL español, guías fútbol americano, noticias NFL'
  },
  '/blog/que-es-la-nfl-guia-completa': {
    title: 'Qué es la NFL: Guía Completa para Principiantes 2026',
    description: 'Descubre qué es la NFL, cómo funciona la liga de fútbol americano, sus 32 equipos, conferencias y todo lo que necesitas saber para empezar a seguirla.',
    keywords: 'qué es la NFL, NFL explicada, liga fútbol americano, equipos NFL, conferencias NFL'
  },
  '/blog/reglas-nfl-explicadas-facil': {
    title: 'Reglas de la NFL Explicadas Fácil | Guía Definitiva 2026',
    description: 'Aprende todas las reglas de la NFL de forma sencilla. Downs, touchdowns, field goals, penalizaciones y todo lo que necesitas para entender un partido.',
    keywords: 'reglas NFL, reglas fútbol americano, downs NFL, touchdown, field goal, penalizaciones NFL'
  },
  '/blog/posiciones-nfl-guia-completa': {
    title: 'Posiciones en la NFL: Guía Completa con Explicaciones',
    description: 'Conoce todas las posiciones de la NFL: quarterback, running back, wide receiver, linebacker y más. Qué hace cada jugador explicado de forma clara.',
    keywords: 'posiciones NFL, quarterback, running back, wide receiver, linebacker, defensive line'
  },
  '/blog/como-funciona-el-super-bowl': {
    title: 'Cómo Funciona el Super Bowl: Todo lo que Debes Saber',
    description: 'Guía completa sobre el Super Bowl: qué es, cómo se llega, historia, show del medio tiempo, anuncios y por qué es el evento deportivo más importante.',
    keywords: 'Super Bowl, final NFL, cómo funciona Super Bowl, historia Super Bowl, halftime show'
  },
  '/blog/como-entender-futbol-americano-desde-cero': {
    title: 'Cómo Empezar a Entender el Fútbol Americano desde Cero',
    description: 'Guía paso a paso para entender el fútbol americano si nunca has visto un partido. Conceptos básicos, consejos y recursos para principiantes absolutos.',
    keywords: 'entender fútbol americano, aprender NFL, principiantes NFL, cómo ver NFL, empezar NFL'
  },
  '/blog/que-hace-un-quarterback': {
    title: 'Qué Hace un Quarterback (QB) en la NFL: Guía Completa',
    description: 'Descubre qué hace un quarterback en el fútbol americano, sus funciones, habilidades necesarias y por qué es la posición más importante de la NFL.',
    keywords: 'quarterback NFL, qué hace un quarterback, QB fútbol americano, mariscal de campo'
  },
  '/blog/que-hace-un-running-back': {
    title: 'Qué Hace un Running Back (RB) en la NFL: Funciones y Ejemplos',
    description: 'Aprende qué hace un running back en el fútbol americano, sus diferentes tipos, habilidades necesarias y los mejores corredores de la historia.',
    keywords: 'running back NFL, qué hace un running back, corredor fútbol americano, RB NFL'
  },
  '/blog/que-hace-un-wide-receiver': {
    title: 'Qué Hace un Wide Receiver (WR) en la NFL: Guía Completa',
    description: 'Descubre qué hace un wide receiver en el fútbol americano, los tipos de rutas que corre, habilidades necesarias y los mejores receptores.',
    keywords: 'wide receiver NFL, qué hace un wide receiver, receptor fútbol americano, WR NFL'
  },
  '/blog/que-hace-un-linebacker': {
    title: 'Qué Hace un Linebacker (LB) en la NFL: Guía Completa',
    description: 'Aprende qué hace un linebacker en el fútbol americano, los diferentes tipos (MLB, OLB), sus responsabilidades y los mejores de la historia.',
    keywords: 'linebacker NFL, qué hace un linebacker, LB fútbol americano, apoyador NFL'
  },
  '/blog/que-es-un-touchdown-nfl': {
    title: 'Qué es un Touchdown en la NFL: Explicación Completa',
    description: 'Aprende qué es un touchdown, cuántos puntos vale, cómo se anota, las diferentes formas de conseguirlo y las reglas en la NFL.',
    keywords: 'touchdown NFL, qué es un touchdown, cuántos puntos touchdown, anotación fútbol americano'
  },
  '/blog/cuanto-dura-un-partido-nfl': {
    title: 'Cuánto Dura un Partido de NFL: Tiempo Real y de Juego',
    description: 'Descubre cuánto dura un partido de fútbol americano de la NFL, por qué dura tanto, la estructura de cuartos, descansos y overtime.',
    keywords: 'duración partido NFL, cuánto dura partido fútbol americano, tiempo partido NFL'
  },
  '/blog/como-funcionan-los-downs-nfl': {
    title: 'Cómo Funcionan los Downs en la NFL: Guía Fácil',
    description: 'Aprende qué son los downs en el fútbol americano, cómo funciona el sistema de primer y diez, qué pasa en cuarto down y todas las reglas.',
    keywords: 'downs NFL, qué son los downs, primer y diez, cuarto down, reglas downs fútbol americano'
  },
  '/blog/cuantos-jugadores-equipo-futbol-americano': {
    title: 'Cuántos Jugadores Hay en un Equipo de Fútbol Americano NFL',
    description: 'Descubre cuántos jugadores tiene un equipo de NFL, cuántos juegan a la vez, la diferencia entre roster activo y squad de práctica.',
    keywords: 'jugadores equipo NFL, cuántos jugadores fútbol americano, roster NFL, 53 jugadores'
  },
  '/que-es-nfl': {
    title: 'Qué es la NFL | Introducción al Fútbol Americano',
    description: 'Aprende qué es la NFL, la liga profesional de fútbol americano. Conoce sus equipos, conferencias, temporada y el objetivo del juego.',
    keywords: 'qué es NFL, liga NFL, fútbol americano, equipos NFL'
  },
  '/reglas': {
    title: 'Reglas del Fútbol Americano | Cómo se Juega la NFL',
    description: 'Todas las reglas básicas del fútbol americano explicadas. Campo, puntuación, downs y formas de jugar una jugada.',
    keywords: 'reglas fútbol americano, cómo se juega NFL, downs, touchdown, field goal'
  },
  '/posiciones': {
    title: 'Posiciones y Roles en la NFL | Guía Completa',
    description: 'Conoce todas las posiciones del fútbol americano: ofensiva, defensiva y equipos especiales. Qué hace cada jugador en el campo.',
    keywords: 'posiciones NFL, quarterback, running back, wide receiver, linebacker'
  },
  '/estrategia': {
    title: 'Estrategia NFL | Formaciones y Tácticas',
    description: 'Aprende estrategia de fútbol americano: formaciones ofensivas y defensivas, tipos de jugadas y conceptos tácticos.',
    keywords: 'estrategia NFL, formaciones fútbol americano, tácticas NFL, jugadas NFL'
  },
  '/estadisticas': {
    title: 'Estadísticas NFL | Stats Tradicionales y Avanzadas',
    description: 'Guía de estadísticas de la NFL: métricas tradicionales y avanzadas como EPA, CPOE y Next Gen Stats explicadas.',
    keywords: 'estadísticas NFL, stats NFL, EPA, passer rating, métricas avanzadas'
  },
  '/historia': {
    title: 'Historia de la NFL | Orígenes y Cultura',
    description: 'Conoce la historia de la NFL desde sus orígenes hasta hoy. Super Bowl, expansión internacional y cultura de afición.',
    keywords: 'historia NFL, orígenes NFL, Super Bowl historia, cultura NFL'
  },
  '/como-ver': {
    title: 'Cómo Ver la NFL en España y Latinoamérica 2026',
    description: 'Guía completa para ver la NFL en español: plataformas, horarios, consejos para principiantes y contenido recomendado.',
    keywords: 'ver NFL España, ver NFL Latinoamérica, NFL en español, horarios NFL'
  },
  '/glosario': {
    title: 'Glosario NFL | Diccionario de Fútbol Americano en Español',
    description: 'Diccionario completo de términos de la NFL en español. Todos los conceptos del fútbol americano explicados de forma clara.',
    keywords: 'glosario NFL, diccionario fútbol americano, términos NFL español'
  },
  '/faq': {
    title: 'Preguntas Frecuentes sobre la NFL | FAQ',
    description: 'Respuestas a las preguntas más comunes sobre la NFL: duración de partidos, diferencias con college, playoffs y más.',
    keywords: 'preguntas NFL, FAQ NFL, dudas fútbol americano'
  }
};

// Component to update document head with SEO data
export const SEOHead = ({ customTitle, customDescription }) => {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    const seo = seoData[path] || seoData['/'];
    
    // Update title
    document.title = customTitle || seo.title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = customDescription || seo.description;
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = seo.keywords || '';
    
    // Add canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = `https://guia-nfl-es.preview.emergentagent.com${path}`;
    
    // Add Open Graph tags
    const ogTags = {
      'og:title': customTitle || seo.title,
      'og:description': customDescription || seo.description,
      'og:type': 'website',
      'og:url': `https://guia-nfl-es.preview.emergentagent.com${path}`,
      'og:site_name': 'Guía NFL en Español'
    };
    
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
    
  }, [location.pathname, customTitle, customDescription]);
  
  return null;
};

export default SEOHead;
